const POIData = [
  {
    id: '1',
    lat: -3.743922925095978,
    long: -38.541993132884365,
    phone: '(85) 3433-8785',
    text: (
      <>
        <h2>Juizado de Violência Doméstica e Familiar Contra a Mulher de Fortaleza</h2>
        <p>
          <b>Endereço:</b> Av. da Universidade, 3281 - Benfica, Fortaleza - CE, 60020-180
        </p>
        <p>
          <b>Horário de Funcionamento:</b> 8h às 18h de segunda à sexta
        </p>
        <p>
          <b>Contato:</b> (85) 3433-8785
        </p>
      </>
    ),
  },
  {
    id: '2',
    lat: -3.7574475125827997,
    long: -38.5597002463776,
    phone: '(85) 3108.2992',
    text: (
      <>
        <h2>Casa da Mulher Brasileira do Ceará</h2>
        <p>
          <b>Endereço:</b> Rua Teles de Souza, s/n - Couto Fernandes
        </p>
        <p>
          <b>Horário de Funcionamento:</b> Plantão 24h todos os dias{' '}
        </p>
        <p>
          <b>Contatos:</b> (85) 3108.2992 / (85) 3108.2931
        </p>
      </>
    ),
  },
  {
    id: '3',
    lat: -3.7576203035266804,
    long: -38.559672895010564,
    phone: '(85) 3108-2952',
    text: (
      <>
        {' '}
        <h2>Delegacia de Defesa da Mulher de Fortaleza (DDM-FOR)</h2>
        <p>
          <b>Endereço:</b> R. Tabuleiro do Norte, s/n - Couto Fernandes, Fortaleza - CE, 60442-040
        </p>
        <p>
          <b>Horário de Funcionamento:</b> Plantão 24h todos os dias Contatos: (85)
        </p>
        <p>
          <b>Contato:</b> (85) 3108- 2950 / (85) 3108-2952
        </p>
      </>
    ),
  },
  {
    id: '4',
    lat: -3.7370471888837784,
    long: -38.6521364445283,
    phone: '(85) 3101-7926',
    text: (
      <>
        <h2>Delegacia de Defesa da Mulher de Caucaia (DDM-C)</h2>
        <p>
          <b>Endereço:</b> Rua Porcina Leite, 113 - Parque Soledade
        </p>
        <p>
          <b>Horário de Funcionamento:</b> Plantão 24h todos os dias
        </p>
        <p>
          <b>Contato:</b> (85) 3101-7926
        </p>
      </>
    ),
  },
  {
    id: '5',
    lat: -3.8742427892731737,
    long: -38.62722027521255,
    phone: '(85) 3371-7835',
    text: (
      <>
        {' '}
        <h2>Delegacia de Defesa da Mulher de Maracanaú (DDM-M)</h2>
        <p>
          <b>Endereço:</b> Rua Padre José Holanda do Vale, 1961 (Altos) - Piratininga
        </p>
        <p>
          <b>Horário de Funcionamento:</b> Plantão 24h todos os dias
        </p>
        <p>
          <b>Contato:</b> (85) 3371-7835
        </p>
      </>
    ),
  },
  {
    id: '6',
    lat: -3.890583666654657,
    long: -38.60849826107439,
    phone: '(85) 3384-5820',
    text: (
      <>
        <h2>Delegacia de Defesa da Mulher de Pacatuba (DDM-PAC)</h2>
        <p>
          <b>Endereço:</b> Rua Marginal Nordeste, 836 - Jereissati III
        </p>
        <p>
          <b>Horário de Funcionamento:</b> Plantão 24h todos os dias
        </p>
        <p>
          <b>Contatos:</b> (85) 3384-5820 / (85) 3384-4203
        </p>
      </>
    ),
  },
  {
    id: '7',
    lat: -3.727026031412932,
    long: -38.50320863103518,
    phone: '(85) 3101-5104',
    text: (
      <>
        {' '}
        <h2>Centro de Referência e Apoio à Vítima de Violência - CRAVV / SPS</h2>
        <p>
          <b>Endereço:</b> Silva Paulet, nº 334, Meireles
        </p>
        <p>
          <b>Horário de Funcionamento:</b> Plantão 24h todos os dias
        </p>
        <p>
          <b>Contato:</b> (85) 3101-5104
        </p>
      </>
    ),
  },
  {
    id: '8',
    lat: -3.773119785664548,
    long: -38.47817404452804,
    phone: '(85) 4102-5429',
    text: (
      <>
        {' '}
        <h2>Instituto Maria da Penha - IMP</h2>
        <p>
          <b>Endereço:</b> Rua Tereza Cristina, 1375 – Centro
        </p>
        <p>
          <b>Contato:</b> (85) 4102-5429
        </p>
      </>
    ),
  },
];

export default POIData;
